import React from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
//import useStyles from './Styles';

interface WrongRixProps {
    isOpen:boolean,
	retry():void,
}

const WrongRix:React.FC<WrongRixProps> = (props)=> {
	//const classes = useStyles();
    if( !props.isOpen ){
        return (null);
    }

    const close = ()=>{

    }

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={false}
			onClose={close}
		>
			<DialogTitle color='primary'></DialogTitle>
			<DialogContent style={{paddingBottom:'3em'}}>
				<p>別の環境（ブラウザやタブ、アプリ）からのアクセスにより、ログイン状態が解除されました。</p>
				<p>ご利用を続ける場合は再度ログインを行ってください。</p>
				<br/>
				<Box style={{textAlign:'center'}}>
					<Link to="/login"><Button variant="contained" color="primary" onClick={props.retry}>再ログインする</Button></Link>
				</Box>
			</DialogContent>
        </Dialog>
    );
}

export default WrongRix;
